<template>
  <div class="unsend-record-box">
    <div class="top">
      <Header ref="header" moduleTitle="预配舱单-上海">
        <template slot="searchBox">
          <UnSendSearch ref="unSendSearch" @fnSearch="searchList" @refreshSearch="refreshSearch" @exportExcel="exportExcel" />
        </template>
      </Header>
    </div>
    <div class="unsend-record-content">
      <div class="btn-div">
        <el-button type="primary" icon="iconfont icon-fasong" :disabled="disabledType" @click="waitSend">发送</el-button>
        <el-button type="primary" icon="el-icon-delete" :disabled="disabledType" @click="deleteMsg">删除</el-button>
      </div>
      <WTable :WTableOpts="WTableOpts" @selection-change="handleSelectionChange">
        <template #masterBillNo="{ row }">
          <div class="flex">
            <div class="table-content">{{ row.masterBillNo }}</div>
            <div class="content-center" v-if="row.masterBillNo" @click="copy(row.masterBillNo)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>
        <template #houseBillNos="scoped">
          <div class="house-box" v-for="(item,idx) in scoped.row.houseBillNos" :key="idx" :style="idx > 0 ? 'border-top: 1px solid #EBEEF5;' : ''">
            <div class="flex">
              <div class="table-content">{{ item }}</div>
              <div class="content-center" v-if="item" @click="copy(item)"><i class="iconfont icon-fuzhi"></i></div>
            </div>
          </div>
        </template>
        <template #shipName="{ row }">
          <div class="flex">
            <div class="table-content max-200">{{ row.shipName }}</div>
            <div class="content-center" v-if="row.shipName" @click="copy(row.shipName)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>
        <template #voyageNo="{ row }">
          <div class="flex">
            <div class="table-content max-200">{{ row.voyageNo }}</div>
            <div class="content-center" v-if="row.voyageNo" @click="copy(row.voyageNo)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>
        <template #carrier="{ row }">
          <span>{{ row.carrier }}</span>
        </template>
        <template #shipAgent="{ row }">
          <span>{{ row.shipAgent }}</span>
        </template>
        <template #newOperator="{ row }">
          <span v-if="row.modifierUser && row.modifierUser.nickname">{{ row.modifierUser.nickname }}</span>
          <span v-else>{{ row.creatorUser ? row.creatorUser.nickname : '/' }}</span>
        </template>
        <template #operation="{ row }">
          <div class="table-btn-box">
            <el-link type="primary" :underline="false" @click="editCps(row)">编辑</el-link>
            <el-link type="primary" :underline="false" @click="copyCps(row)">复制</el-link>
            <!-- <el-link type="primary" :underline="false" @click="exportCopyCps(row)">导出确认件</el-link> -->
          </div>
        </template>
      </WTable>
      <div class="pagination" v-if="total > 0">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" />
      </div>
    </div>

    <!-- 发送-费用确认提示 -->
    <SendFeeTip v-if="sendFeeTipVisible" :visible="sendFeeTipVisible" :feeData="feeData" @closeDialog="closeFee" @sendSuccess="sendSuccess" />
    <!-- 发送-混拼拦截提示 -->
    <SendMixTip v-if="sendMixTipVisible" :visible="sendMixTipVisible" :dialogData="dialogData" @enterGo="enterGo" @closeDialog="closeDialog" />
    <!-- 发送-箱号不符合提示 -->
    <SendNoTip v-if="sendNoTipVisible" :visible="sendNoTipVisible" :dialogData="dialogData" @enterGo="enterGo" @closeDialog="closeDialog" />
    <!-- 发送-重复舱单提示 -->
    <SendRepeatTip v-if="sendRepeatTipVisible" :visible="sendRepeatTipVisible" :dialogData="dialogData" :sendStatus="sendStatus" @enterGo="enterGo" @closeDialog="closeDialog" />
  </div>
</template>

<script>
import SendFeeTip from '@/views/new_cps/unsendRecord/SendFeeTip'
import SendMixTip from '@/views/new_cps/unsendRecord/SendMixTip'
import SendNoTip from '@/views/new_cps/unsendRecord/SendNoTip'
import SendRepeatTip from '@/views/new_cps/unsendRecord/SendRepeatTip'
import Header from "@/components/cps2/Header"
import UnSendSearch from "./search/UnSendSearch.vue"
import { httpAgent } from "@/api/ajax";

export default {
  name: "UnSendRecord",
  components: { SendFeeTip,SendMixTip,SendNoTip,SendRepeatTip,Header,UnSendSearch},
  props: {
    refreshUnSend: {
      type: String,
      default: ''
    },
  },
  data(){
    return {
      total: 0, // 总数 
      pageNum: 1, // 页码 
      pageSize: 10, // 条数
      chooseList: [], // 选中数据
      searchData: {}, // 搜索数据
      sendFeeTipVisible: false, // 发送费用确认提示
      sendMixTipVisible: false, // 发送-混拼拦截提示
      sendNoTipVisible: false, // 发送-箱号不符合提示
      sendRepeatTipVisible: false, // 发送-重复舱单提示
      sendStatus: 5,
      dialogData: {}, // 校验弹窗 数据
      feeData: {}, // 价格数据

      fileTemplate: {
        name: 'CPS模版.xlsx',
        url: 'https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/template/VGM%E6%95%B0%E6%8D%AE%E6%A8%A1%E6%9D%BF.xlsx'
      },
      WTableOpts: {
        data: [], // 列表数据
        tableAttrs: { border: false },
        tableColAttrs: [
          { type: 'selection',fixed:"left" },
          { prop: '', label: '主提单号', slotName: 'masterBillNo', width: '320px' },
          { prop: '', label: '分提单号', slotName: 'houseBillNos', width: '320px' },
          { prop: '', label: '船名', slotName: 'shipName', width: '230px' },
          { prop: '', label: '航次', slotName: 'voyageNo', width: '230px' },
          { prop: '', label: '船公司', slotName: 'carrier', width: '150px' },
          { prop: '', label: '船代', slotName: 'shipAgent', width: '100px' },
          { prop: 'totalPackages', label: '总件数', width: '100px'  },
          { prop: 'totalGrossWeight', label: '总毛重', width: '100px'  },
          { prop: 'totalVolume', label: '总体积', width: '100px'  },
          { prop: '', label: '提交人', slotName: 'newOperator', width: '150px'},
          { prop: 'gmtModified', label: '编辑时间', 'min-width': '200px' },
          { prop: '', label: '操作', width: '200px', slotName: 'operation',fixed:"right"  }
        ]
      },
      headers:{
        token: localStorage.getItem('userToken'),
      },
      
    }
  },
  computed: {
    // 删除 按钮状态
    disabledType(){
      return this.chooseList.length > 0 ? false : true
    }
  },
  watch: {
    refreshUnSend(newName, oldName){
      if(newName) {
        this.pageSize = 10
        this.pageNum = 1
        this.getList()
      }
    }
  },
  created(){
    this.getList()
    //请求头信息补充
    let domain = '';
    if (window.location.host.split('.')[0] == 'www') {
      domain = window.location.host.split('.')[1];
    } else {
      domain = window.location.host.split('.')[0];
    }
    this.headers['X-company-domain'] = domain;
  },
  async mounted(){
    await this.$refs.unSendSearch.firstClick()
    await this.$refs.unSendSearch.fnSearch()
  },
  methods: {
    // 获取列表
    getList(){
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ...this.searchData,
        type: 'WAITING'
      }
      httpAgent({
        url: `/agent/ccam/drafts`,
        method: "get",
        data:params
      }).then((res) => {
        this.WTableOpts.data = res.records
        this.total = res.total
        if(this.pageNum > 1 && res.records.length == 0){
          this.pageNum = this.pageNum -1
          this.getList()
        }
      })
    },
    // 导出
    exportExcel(query){
      if(!query.gmtModifiedBegin && !query.gmtModifiedEnd){
        this.$message({
          message: '请选择时间',
          type: 'error'
        })
        return
      }
      query.token = this.headers.token;
      query['X-company-domain'] = this.headers['X-company-domain'];
      let keys = Object.keys(query);
      let arr = '';
      for(let i=0;i<keys.length;i++){
        if(query[keys[i]]){
          arr = arr + '&' + keys[i] + '=' + query[keys[i]]
        }
      }
      arr = arr.substring(1);
      let url = '/agent/ccam/export/draft?'+arr;
      console.log(url);
      window.open(url);
      // httpAgent({
      //   url: `/agent/ccam/export/draft`,
      //   method: "get",
      //   data: query,
      //   responseType: "blob"
      // }).then((res) => {
      //   download(res, `${'CPS导出数据'}.xlsx`)
      // })
    },
    // 校验后 确认价格
    enterGo(data){
      console.log(data)
      this.closeDialog()
      this.dialogData = {}

      this.$nextTick(() => {
        if(data.index == 6){
          httpAgent({
            url: `/agent/ccam/drafts/checkFee`,
            method: "post",
            data:{
              ids: data.ids,
              useCouponAmount: 0
            }
          }).then((res) => {
            this.sendFeeTipVisible = true
            this.feeData = { ...res, ids: data.ids }
          })
        } else {
          let arrList = data.res
          // let response = arrList.splice(0, data.index)
          console.log(arrList,'arrList===========')
          let dialogList = data.arr
          for(let i = data.index + 1; i< arrList.length; i++ ){
            console.log(dialogList)
            if(arrList[i].show){
              console.log(i)
              delete dialogList[i]
              console.log(dialogList)
              this.dialogData = { arr: dialogList, ids: this.chooseList, index: i, content: arrList[i].content, res: arrList, type: arrList[i].type  }
              /*** 存在箱号混拼 */
              if(arrList[i].type == 'CONTAINERNO_HYBRID'){
                this.sendMixTipVisible = true
                return
              }
              /*** 本人6小时内发过此单 */
              if(arrList[i].type == 'SELF_SIX_HOURS'){
                this.sendRepeatTipVisible = true
                return
              }
              /*** 本人30天内发过此单 */
              if(arrList[i].type == 'SELF_THIRTY_DAYS'){
                this.sendRepeatTipVisible = true
                return
              }
              /*** 同事30天内发过此单 */
              if(arrList[i].type == 'OTHERS_THIRTY_DAYS'){
                this.sendRepeatTipVisible = true
                return
              }
              /*** 其他公司30天内发过此单 */
              if(arrList[i].type == 'OTHERS_COMPANY_THIRTY_DAYS'){
                this.sendRepeatTipVisible = true
                return
              }
              /*** 其他公司30天内发过此箱号 */
              if(arrList[i].type == 'CONTAINERNO_EXISTS'){
                this.sendRepeatTipVisible = true
                return
              }
              
              /*** 存在箱号不符合国际规范 */
              if(arrList[i].type == 'CONTAINERNO_ERROR'){
                this.sendNoTipVisible = true
                return
              }

              /*** 通过校验 */
              if(arrList[i].type == 'IS_TURE'){
                this.enterGo({ ids: this.chooseList, index: 6 })
              }
              
            } else {
              delete dialogList[i]
            }
          }
        }
      })
      
      
    },
    // 校验
    waitSend(){
      httpAgent({
        url: `/agent/ccam/drafts/checkCcamSend`,
        method: "post",
        data:this.chooseList
      }).then((res) => {
        console.log(res)
        let dialogList = [...res] 
        console.log(dialogList)
        for(let i = 0; i< res.length; i++ ){
          console.log(dialogList)
          if(res[i].show){
            console.log(i)
            delete dialogList[i]
            console.log(dialogList)
            this.dialogData = { arr: dialogList, ids: this.chooseList, index: i, content: res[i].content, res: res,  type: res[i].type  }
            /*** 存在箱号混拼 */
            if(res[i].type == 'CONTAINERNO_HYBRID'){
              this.sendMixTipVisible = true
              return
            }
            /*** 本人6小时内发过此单 */
            if(res[i].type == 'SELF_SIX_HOURS'){
              this.sendRepeatTipVisible = true
              return
            }
            /*** 本人30天内发过此单 */
            if(res[i].type == 'SELF_THIRTY_DAYS'){
              this.sendRepeatTipVisible = true
              return
            }
            /*** 同事30天内发过此单 */
            if(res[i].type == 'OTHERS_THIRTY_DAYS'){
              this.sendRepeatTipVisible = true
              return
            }
            /*** 其他公司30天内发过此单 */
            if(res[i].type == 'OTHERS_COMPANY_THIRTY_DAYS'){
              this.sendRepeatTipVisible = true
              return
            }
            /*** 其他公司30天内发过此箱号 */
            if(res[i].type == 'CONTAINERNO_EXISTS'){
              this.sendRepeatTipVisible = true
              return
            }
            
            /*** 存在箱号不符合国际规范 */
            if(res[i].type == 'CONTAINERNO_ERROR'){
              this.sendNoTipVisible = true
              return
            }

            /*** 通过校验 */
            if(res[i].type == 'IS_TURE'){
              this.enterGo({ ids: this.chooseList, index: 6 })
            }
            
          } else {
            delete dialogList[i]
          }
        }
      })
    },
    // 删除
    deleteMsg(){
      this.$confirm('确定要删除当前数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        httpAgent({
          url: `/agent/ccam/drafts`,
          method: "delete",
          data:this.chooseList
        }).then((res) => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList()
        })
      })
    },
    // 编辑舱单
    editCps({ id }){
      httpAgent({
        url: `/agent/ccam/drafts/${id}`,
        method: "get",
      }).then((res) => {
        let data = {
          btn: 'EDIT',
          btnName: '编辑舱单',
          type: 'WAITING',
          to: 'DETAIL',
          name: '待发送',
          ...res,
          id: res.id,
        }
        this.$router.push({
          name:"cpsDetail",
          query:data
        })
      })
    },
    // 复制舱单
    copyCps({ id }){
      httpAgent({
        url: `/agent/ccam/drafts/${id}`,
        method: "get",
      }).then((res) => {
        let response = { ...res }
        response.content.masterBillNo = ''
        let data = {
          btn: 'COPY',
          btnName: '复制舱单',
          type: 'WAITING',
          to: 'DETAIL',
          name: '待发送',
          ...response
        }
        this.$router.push({
          name:"cpsDetail",
          query:data
        })
      })
    },
    // 复制
    copy(e){
      this.$copyText(e)
			this.$message({
				type: 'success',
				message: '复制成功!'
			})
    },
    // table 选择
    handleSelectionChange(e){
      this.chooseList = []
      this.chooseList = e.map(o => { return o.id })
    },
    // 重置
    refreshSearch(){
      this.searchData = {}
      this.$refs.unSendSearch.refreshTime()
    },
    // 发送成功
    sendSuccess(data){
      this.$message({
        message: '发送成功',
        type: 'success'
      })
      this.$refs.header.getAccount()
      this.getList()
      console.log(data)
      if(data && data.id){
        //发送舱单判断vgm导流是否支持
        httpAgent({
          url: `/agent/ccam/orders/isCcamSendVGM/${data.id}`,
          method: "get",
        }).then((res) => {
          if(res){
            this.$message({
              message: '提交成功',
              type: 'success'
            })
            // this.$confirm('提交成功，是否继续发送以下业务?', '提示', {
            //   confirmButtonText: '发送VGM',
            //   cancelButtonText: '取消',
            //   type: 'warning'
            // }).then(() => {
            //   this.$router.push({
            //     name:"vgm",
            //     query:{
            //       sendVGMId:data.id
            //     }
            //   })
            // }).catch(() => {});
          }
        })
      }
    },
    // 点击查询
    searchList(query){
      this.searchData = query
      this.pageNum = 1
      this.pageSize = 10
      this.getList()
    },
    // 切换条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.getList()
    },
    // 切换页码
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val
      this.getList()
    },
    // 价格弹窗
    closeFee(){
      this.sendFeeTipVisible = false
    },
    // 无逻辑 弹窗关闭
    closeDialog(){
      this.sendMixTipVisible = false
      this.sendNoTipVisible = false
      this.sendRepeatTipVisible = false
    }
  }
};
</script>

<style scoped lang="less">
.unsend-record-box {
  font-size: 14px;
  color: #333333;
  display: flex;
  flex-direction: column;
  height: 100%;
  .unsend-record-content {
    position: relative;
    background: #ffffff;
    border-radius: 4px;
    padding: 24px;
    height: 100%;
  }
  .btn-div {
    margin-bottom: 24px;
  }

  .house-box {
    height: 54px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .table-content {
    max-width: 290px;
    margin-right: 10px;
  }
  .max-200 {
    max-width: 200px;
  }

  .icon-fuzhi {
    color: #1170eb;
    font-size: 12px;
    cursor: pointer;
  }
  .icon-shuaxin {
    font-size: 14px;
    color: #000000;
    cursor: pointer;
  }
}
</style>
